<template>
  <KDialog
    :loading="loading"
    :title="title"
    :visible="visible"
    showClose
    :actions="actions"
    @click:add="save"
    @click:edit="save"
    @click:close="close"
  >
    <k-form ref="form">
      <v-row class="ma-0">
        <!-- Nome da Configuração -->
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            :rules="[$validation.isRequired]"
            label="Nome"
            :error-messages="errors.name"
            v-model="form.name"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <!-- Categoria -->
        <v-col cols="12" sm="6" v-if="form.category_id">
          <v-select
            dense
            :items="rootItems"
            item-value="id"
            item-text="name"
            inset
            outlined
            label="Categoria"
            :error-messages="errors.category_id"
            v-model="form.category_id"
            persistent-hint
            required
          ></v-select>
        </v-col>

        <!-- Ícone -->
        <v-col cols="12" sm="6" v-else>
          <KInputIcon
            dense
            outlined
            :rules="[$validation.isRequired]"
            label="Ícone"
            :error-messages="errors.icon"
            v-model="form.icon"
            persistent-hint
            required
          ></KInputIcon>
        </v-col>
      </v-row>
    </k-form>
  </KDialog>
</template>

<script>
import KDialog from "@/components/KDialog";
import KForm from "@/components/KForm";
import KInputIcon from "@/components/KInput/Icon";

export default {
  components: {
    KDialog,
    KInputIcon,
    KForm,
  },

  data() {
    return {
      // Define se está visível
      visible: false,
      // Armazena os dados que virão via função para preencher
      form: {},

      isEditing: false,
      title: null,

      loading: false,

      //
      errors: {},
    };
  },

  computed: {
    actions() {
      if (this.isEditing) {
        return [
          {
            eventName: "click:edit",
            label: "Salvar Alterações",
          },
        ];
      }

      return [{ eventName: "click:add", label: "Cadastrar" }];
    },

    rootItems() {
      return this.$store.getters["financial_categories/all"].filter(
        item => !item.category_id
      );
    },
  },

  methods: {
    /*******************************************************
     *
     *  FUNÇÕES PARA SALVAR E EDITAR OS DADOS NO STORE
     *
     *******************************************************/

    /**
     * Salva os dados no Store
     */
    async save() {
      try {
        //
        this.errors = {};
        // Se as demais validações passaram
        if (this.$refs["form"].validate()) {
          this.loading = true;
          //
          await this.$store.dispatch("financial_categories/save", {
            payload: this.form,
            editing: this.isEditing,
          });

          this.loading = false;
          this.$message.success("Registro salvo com sucesso");
          this.close();
        } else {
          this.$message.error("Verifique os campos marcados em vermelho");

          this.loading = false;
        }
      } catch (error) {
        this.errors = this.$message.serverError(error);
        this.loading = false;
      }
    },

    /*******************************************************
     *
     *  FUNÇÕES BÁSICAS DE QUALQUER DIALOG
     *
     *******************************************************/

    /**
     * Abre o dialog preparado para cadastrar um novo dado
     */
    openToAdd(payload = {}) {
      // Limpa os dados
      this.clear();

      //
      this.form = this.$clone(payload);
      // Altera o título
      this.title = "Cadastrar nova categoria";

      // Define se é uma edição
      this.isEditing = false;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog preparado para alteerar os dados
     */
    openToEdit(payload) {
      // Altera o título
      this.title = `Editar "${payload.name}"`;

      // Mescla os dados recebidos para não alterar o que está para trás
      this.form = this.$clone(payload);

      // Define se é uma edição
      this.isEditing = true;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog
     */
    open() {
      this.visible = true;
    },

    /**
     * Fecha o dialog
     */
    close() {
      this.visible = false;
      this.clear();
      this.$refs.form.resetValidation();
    },

    /**
     * Limpa os dados do dialog
     */
    clear() {
      this.form = {};
    },
  },
};
</script>

<style>
</style>
